var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudible(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.0892L23 10.017V11.9272L12 19L1 11.9272V10.017L12 17.0892ZM11.997 8.24681C14.4745 8.24681 16.6572 9.54701 17.9352 11.5208H17.9334L16.3143 12.5625C13.8787 9.22504 9.42294 8.64711 6.33635 11.2796C6.24583 11.3567 6.15831 11.4362 6.07199 11.517L6.0618 11.5158C7.33984 9.54516 9.52125 8.24681 11.997 8.24681ZM11.997 11.4936C13.3458 11.4936 14.5381 12.1857 15.2562 13.2428H15.2556L13.6935 14.2476C12.9651 13.2157 11.9041 12.565 10.7226 12.565C10.0038 12.565 9.33063 12.8062 8.74856 13.2262C9.4685 12.1783 10.6548 11.4936 11.997 11.4936ZM4.56196 8.64155C4.16632 8.96352 3.72512 9.4255 3.38463 9.79434C5.23755 6.89109 8.44043 5 11.9964 5C15.6033 5 18.7762 6.9096 20.613 9.80113V9.80051L18.9363 10.875L18.9135 10.8392C15.5002 5.94061 9.09084 4.95251 4.56196 8.64155Z",
    fill: "#F7991C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudible);
export default __webpack_public_path__ + "static/media/audible.e357a692.svg";
export { ForwardRef as ReactComponent };